import { useState } from 'react';
import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { DialKeypad } from './dial-keypad';

interface InCallKeypadPanelProps {
    readonly onBack: () => void;
    readonly onPress: (digit: string) => void;
}

/** DTMF overlay shown during an active call — sends real digits via the SDK. */
export function InCallKeypadPanel({ onBack, onPress }: InCallKeypadPanelProps) {
    const [sent, setSent] = useState('');

    const handlePress = (digit: string): void => {
        setSent((s) => s + digit);
        onPress(digit);
    };

    return (
        // Without `flex-1` here the child DialKeypad's own `flex-1` had no
        // definite parent height to divide, so the in-call keypad never grew
        // with the widget at all.
        <div className="flex min-h-0 flex-1 flex-col gap-3 p-[calc(1rem*var(--voice-scale,1))]">
            <div className="flex items-center gap-2">
                <Button
                    type="button"
                    variant="ghost"
                    size="icon-sm"
                    onClick={onBack}
                    aria-label="Back to call"
                >
                    <ArrowLeft className="size-4" />
                </Button>
                <p className="min-h-5 flex-1 truncate text-center text-[calc(1rem*var(--voice-scale,1))] font-medium tracking-[0.15em] text-text-primary tabular-nums">
                    {sent}
                </p>
            </div>
            <DialKeypad onPress={handlePress} />
        </div>
    );
}
